import { type FC, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { AlertType, useAlertEmit } from "../common/alert/Alert";
import { useCompany } from "../company/useCompany";
import { Button } from "../components/Button";
import { IcpEditor } from "../dashboard/onboard/IcpEditor";
import { useOnboarding } from "../dashboard/onboard/useOnboarding";

export const TabIdealCustomerEdit: FC = () => {
	const company = useCompany();
	const emit = useAlertEmit();
	const { idealCustomerProfile } = useOnboarding();

	const icps = useMemo(() => company.icps, [company]);

	const handleGenerate = async () => {
		await idealCustomerProfile.mutateAsync(undefined, {
			onSuccess: () => {
				emit({
					type: AlertType.SUCCESS,
					content: "Successfully generated ideal customer profiles",
				});
			},
			onError: () => {
				emit({
					type: AlertType.ERROR,
					content: "Error when generating ideal customer profiles",
				});
			},
		});
	};

	return (
		<Row>
			{icps.length > 0 ? (
				<>
					{icps.map((icp) => (
						<Col md={6} key={`ICP-editor-${icp.id}-${icp.company_id}`}>
							<IcpEditor icp={icp} />
						</Col>
					))}
					<Col xs={12} className="mt-3">
						<Button
							variant="ghost"
							loading={idealCustomerProfile.isPending}
							onClick={handleGenerate}
						>
							Regenerate Profiles
						</Button>
					</Col>
				</>
			) : (
				<Col>
					<p>
						No ideal customer profiles found. Generate profiles to help
						personalize your marketing content.
					</p>
					<Button
						loading={idealCustomerProfile.isPending}
						onClick={handleGenerate}
					>
						Generate Ideal Customer Profiles
					</Button>
				</Col>
			)}
		</Row>
	);
};
